query AnalyticsViewsByDeviceOs($filter: AnalyticsViewsFilterInput!) {
  analyticsViews(filter: $filter) {
    viewsByDeviceOs {
      label
      views
    }
  }
}
